import { createAxios } from "../helpers/createAxios";

const axiosInstance = createAxios();

export const downloadProductDoc = async (endpoint, fallbackName = 'documento.pdf') => {
    try {
        const response = await axiosInstance.get(endpoint, {
            responseType: 'blob',
        });
        const blob = new Blob([response.data], {
            type: response.headers['content-type'] || 'application/pdf',
        });
        const blobUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = fallbackName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(blobUrl);
        return true;
    } catch (error) {
        console.error('Error downloading product file:', error);
        throw error;
    }
};

export default downloadProductDoc;
